// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__v6mVr","colMin":"styles_colMin__5zDBb","colCheckbox":"styles_colCheckbox__1ckeT"};